<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="15vh"
    :modal-append-to-body="false"
    :before-close="handleClose"
    custom-class="custom-scrollable"
  >
    <div test-id="main">
      <div v-if="currentView === 'depositType'" class="font-normal">
        <div class="dialog-header pb-10 -mt-10">
          <div
            class="text-lg md:text-xl still-clean-commit lg:text-2xl text-root-2 font-bold flex justify-center"
          >
            Select Deposit Type
          </div>
          <div
            class="text-root-4 h-11 mb-2 flex flex-col items-center justify-center font-normal text-xs mt-10"
          >
            <div class="flex items-center justify-center">
              <div
                class="my-3 font-bold bg-root-3 mx-2 mt-3 flex px-1 justify-between items-center rounded-full"
              >
                <div
                  @click="changeType('fiat')"
                  :class="
                    type === 'fiat'
                      ? 'bg-primary text-white my-1 text-root-4 rounded-full'
                      : ''
                  "
                  class="text-xs md:text-13px rounded-full transition duration-700 ease-in-out cursor-pointer px-2.5 py-3 md:px-6 text-root-1"
                >
                  Fiat Currency
                </div>
                <div
                  v-if="tenantPermission('asset-access')"
                  @click="changeType('asset')"
                  :class="
                    type === 'asset'
                      ? 'bg-primary text-white my-1 px-6 text-root-4 rounded-full'
                      : ''
                  "
                  class="text-xs md:text-13px rounded-full transition duration-700 ease-in-out cursor-pointer px-2.5 py-3 md:px-6 text-root-1"
                >
                  Asset Transfer
                </div>
              </div>
            </div>
            <div
              class="bg-root-yellow small-text py-1 border border-yellow-10 text-root-yellow rounded-md px-1 md:px-4 items-center flex text-center"
              style="word-break: normal"
              v-if="pendingDepositDetails"
            >
              <warning-icon class="mr-2 md:mr-4 md:-mt-2" /> You currently have
              a pending deposit and can only <br />
              edit your wire transfer (International) deposit.
            </div>
            <div v-else class="mx-10 italic flex text-center">
              {{
                type === 'fiat'
                  ? 'Wire transfer: This process takes about 2-4 business days'
                  : 'Arrives within 60 minutes'
              }}
            </div>
          </div>
        </div>
        <el-form
          :model="depositForm"
          ref="depositForm"
          :rules="rules"
          size="normal"
          class=""
        >
          <el-form-item label="Select Currency" prop="currency">
            <el-select
              class="w-full"
              v-model="depositForm.currency"
              placeholder="Select Currency"
              @change="changeCurrency"
            >
              <el-option
                v-for="item in type === 'fiat' ? currency : currencyUsdc"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="w-full" label="Enter an Amount" prop="amount">
            <el-input
              @input="convertLocalToUsd"
              prop="amount"
              class=""
              v-model="depositForm.amount"
              name="amount"
              placeholder=""
            >
              <i slot="suffix" class="mr-2">
                {{
                  this.type === 'asset'
                    ? 'USDC'
                    : !isLocalCountry
                    ? 'USD'
                    : country.currency
                }}</i
              >
            </el-input>
            <div
              v-if="isLocalCountry"
              class="flex text-root-2 font-bold justify-between"
            >
              <span>
                Rate: {{ country.symbol }}{{ exchangeRateBase }} to $1</span
              >
              <span> You receive: {{ parseMoney(localToUsd) }}</span>
            </div>
          </el-form-item>
          <el-form-item
            :label="
              type === 'asset'
                ? 'Network'
                : this.depositForm.currency === 'NGN'
                ? 'Select transfer type'
                : 'Select Transfer Location'
            "
            prop="location"
          >
            <el-radio-group
              class="w-full mt-6"
              v-model="depositForm.location"
              @change="selectLocation"
            >
              <el-radio
                v-for="item in type === 'asset'
                  ? usdcNetworks
                  : !isLocalCountry
                  ? transferLocations
                  : transferType"
                :key="item.value"
                :label="item.value"
                :value="item.value"
                :disabled="item.disabled"
                class="mb-6 text-root-4"
                >{{ item.label }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-form>
        <el-button
          @click="validateForm('depositForm')"
          :loading="isLoading"
          class="mt-4 border-none text-white bg-primary w-full rounded-full py-4"
        >
          Next
        </el-button>
      </div>
      <div v-if="currentViewAccountInfo">
        <account-information
          @goBack="showTransferType"
          @completedDeposit="toShowPendingDeposit"
          @closeDialog="closeDialog"
          :currentTransaction="transaction"
          @goBackToPendingDialog="goBackToPendingDialog"
        />
      </div>
      <div v-if="currentViewLocalAccountInfo">
        <local-account-information
          @completedDeposit="toShowPendingDeposit"
          @closeDialog="closeDialog"
          :currentTransaction="transaction"
        />
      </div>
      <div v-if="currentViewAssetAccountInfo">
        <asset-account-information
          @completedDeposit="toShowPendingDeposit"
          @closeDialog="closeDialog"
          :currentTransaction="transaction"
        />
      </div>
      <div>
        <plaid-accounts-dialog
          @depositTypeScreen="depositTypeScreen"
          v-if="currentView === 'plaidAccountsView'"
          @goBack="showTransferType"
          @closeDialog="closeDialog"
        />
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { FormatAmount, ParseMoney, ParseLocalToUsd } from '@/utils/helpers'
import {
  TRANSFER_LOCATIONS,
  USDC_NETWORKS,
  TRANSFER_TYPE,
  LOCAL_COUNTRIES
} from '@/utils/constants'
import breakpoints from '@/utils/breakpoints.js'
import pendingDeposit from '@/mixins/pendingDeposit.js'
import localDeposit from '@/mixins/localDeposit.js'
import country from '@/mixins/getCountryDetails.js'
import tenant from '@/mixins/tenant.js'

export default {
  mixins: [pendingDeposit, country, localDeposit, tenant],

  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      transaction: {},
      transferLocations: TRANSFER_LOCATIONS,
      type: 'fiat',
      currency: [
        { label: 'USD($)', value: 'USD', symbol: '$', disabled: false },
        { label: 'NGN(₦)', value: 'NGN', symbol: '₦', disabled: false },
        { label: 'GHS(₵)', value: 'GHS', symbol: '₵', disabled: false }
      ],
      currencyUsdc: [{ label: 'USDC($)', value: 'USDC', symbol: '$' }],
      usdcNetworks: USDC_NETWORKS,
      rules: {
        amount: [
          {
            required: true,
            message: 'Amount is required',
            trigger: ['blur', 'change']
          },
          { validator: this.validateAmount, trigger: ['blur', 'change'] }
        ],
        location: [
          {
            required: true,
            message: 'Required',
            trigger: ['blur', 'change']
          }
        ],
        network: [
          {
            required: true,
            message: 'Network is required',
            trigger: ['blur', 'change']
          }
        ],
        currency: [
          {
            required: true,
            message: 'Currency is required',
            trigger: ['blur', 'change']
          }
        ]
      },
      isLoading: false,
      currencySymbol: '$',
      transferType: TRANSFER_TYPE,
      breakpoints,
      disabledAccount: false,
      depositForm: { amount: '', currency: 'USD', location: '' },
      localToUsd: 0
    }
  },
  methods: {
    depositTypeScreen () {
      this.$store.dispatch('transactions/setDepositTypeView', 'depositType')
    },
    closeShowPlaidWidget () {},
    validateAmount (rule, value, callback) {
      if (!FormatAmount(value) || FormatAmount(value) < 1) {
        callback(new Error('Amount must be greater than 0'))
      } else {
        callback()
      }
    },
    selectLocation () {},
    closeDialog () {
      this.$emit('closeDialog')
    },
    goBackToPendingDialog () {},
    async getTransactions () {
      const vm = this
      const payload = {
        number: 1,
        status: '',
        type: '',
        from: '',
        to: ''
      }
      await this.$store
        .dispatch('transactions/getTransactions', payload)
        .then(() => {})
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.$message({
            showClose: true,
            message: this.httpErrorMessage,
            type: 'error'
          })
        })
    },
    parseMoney (val) {
      return ParseMoney(val)
    },
    convertLocalToUsd () {
      const localAmount = FormatAmount(this.depositForm.amount)
      this.localToUsd = ParseLocalToUsd(localAmount, this.exchangeRateBase)
      return this.localToUsd || 0
    },
    async initiateDepositAmount () {
      const vm = this
      const details = [
        {
          amount: FormatAmount(this.depositForm.amount),
          currency: this.depositForm.currency
        }
      ]
      this.isLoading = true
      await this.$store
        .dispatch('transactions/initiateDeposit', { details })
        .then(() => {
          this.getTransactions()
          const transaction =
            this.$store.state.transactions.transactions.items[0]
          this.$store.dispatch(
            'transactions/setCurrentTransaction',
            transaction
          )
          this.$store.dispatch(
            'transactions/setDepositTypeView',
            'accountInformation'
          )
        })
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.$message({
            showClose: true,
            message: this.httpErrorMessage,
            type: 'error'
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async initiateLocalDepositAmount () {
      const vm = this
      const details = {
        amount: FormatAmount(this.depositForm.amount),
        currency: this.depositForm.currency
      }
      this.isLoading = true
      await this.$store
        .dispatch('transactions/initiateLocalDeposit', { ...details })
        .then(() => {
          this.getTransactions()
          // const transaction =
          //   this.$store.state.transactions.transactions.items[0]
          // this.$store.dispatch('transactions/setCurrentTransaction',
          //   transaction
          // )
          this.$store.dispatch(
            'transactions/setDepositTypeView',
            'localAccountInformation'
          )
        })
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.$message({
            showClose: true,
            message: this.httpErrorMessage,
            type: 'error'
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    proceed () {
      const vm = this
      if (this.type === 'fiat') {
        if (
          this.depositForm.location !== 'Plaid' ||
          this.depositForm.location !== 'Local Currency'
        ) {
          this.$store.dispatch(
            'transactions/wireTransferType',
            this.depositForm.location
          )
        }
        if (this.depositForm.location === 'Plaid') {
          if (this.pendingPlaidDeposit) {
            vm.$message({
              showClose: true,
              message: 'You currently have an ACH transaction in progress',
              type: 'info',
              duration: 5000
            })
          } else {
            this.$store.dispatch(
              'transactions/setDepositTypeView',
              'plaidAccountsView'
            )
            this.$store.dispatch(
              'transactions/setPlaidDepositAmount',
              FormatAmount(this.depositForm.amount)
            )
          }
        } else if (this.depositForm.location === 'Local Currency') {
          this.initiateLocalDepositAmount()
        } else {
          this.initiateDepositAmount()
        }
      } else {
        this.depositUsdc()
      }
    },
    toShowPendingDeposit () {
      this.$emit('closeDialog')
      this.$emit('completedDeposit')
    },
    changeType (type) {
      if (this.transaction && Object.keys(this.transaction).length > 0) {
        return
      }
      this.type = type
      this.depositForm.amount = ''
      this.depositForm.currency = ''
      this.depositForm.location = ''
    },
    changeCurrency () {
      const localCountry = LOCAL_COUNTRIES.find(
        (localCountry) => localCountry.currency === this.depositForm.currency
      )
      if (this.isLocalCountry) {
        this.depositForm.location = 'Local Currency'
        if (localCountry.name !== this.$store.state.common.activeCountry) {
          this.$store.dispatch('common/setActiveCountry', localCountry.name)
        }
      } else {
        this.depositForm.location = ''
      }
      this.currencySymbol = this.isLocalCountry ? this.country.symbol : '$'
      this.depositForm.amount = 0
    },
    depositUsd () {
      const pendingDeposit = this.latestTransactions.filter(
        (transaction) =>
          transaction.status === $STATUS.PENDING &&
          transaction.type === 'deposit'
      )
      if (pendingDeposit.length > 0) {
        this.$emit('closeDialog')
        this.$emit('hasPendingDeposit')
      } else {
        this.$emit('closeDialog')
        this.$emit('showFiatCurrency')
      }
    },
    validateForm (depositForm) {
      this.$refs[depositForm].validate((valid) => {
        if (valid) {
          this.proceed()
        } else {
          this.$notify.error({
            title: 'Incomplete',
            message: 'please complete details',
            position: 'top-right'
          })
        }
      })
    },
    showTransferType () {
      this.$store.dispatch('transactions/setDepositTypeView', 'depositType')
    },
    async depositUsdc () {
      this.isLoading = true
      const vm = this
      await this.getWalletAddresses()
        .then(() => {
          if (!this.walletAddress) {
            this.disabledAccount = true
            vm.$message({
              showClose: true,
              message:
                'Your account is awaiting further verification. Once that is done the disabled payment method would be enabled.',
              type: 'info',
              duration: 6000
            })
            this.isLoading = false
          } else {
            this.$emit('closeDialog')
            this.$emit('showWallet', this.walletAddress)
          }
        })
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.$message({
            showClose: true,
            message: this.httpErrorMessage,
            type: 'error'
          })
          this.isLoading = false
        })
    },
    handleClose () {
      this.$emit('closeDialog')
    }
  },
  computed: {
    isLocalCountry () {
      const localCountry = LOCAL_COUNTRIES.find(
        (localCountry) => localCountry.currency === this.depositForm.currency
      )
      return !!localCountry
    },
    currentViewAccountInfo () {
      return (
        this.currentView === 'accountInformation' ||
        this.currentView === 'depositDetails' ||
        this.currentView === 'pendingDepositDetails'
      )
    },
    currentViewLocalAccountInfo () {
      return this.currentView === 'localAccountInformation'
    },
    currentViewAssetAccountInfo () {
      return this.currentView === 'assetAccountInformation'
    },
    achDepositToken () {
      return this.$store.state.transactions.achDepositInfo
    },
    currentTransaction () {
      return this.$store.state.transactions.currentTransaction
    },
    currentView () {
      return this.$store.state.transactions.depositTypeView
    },
    latestTransactions () {
      if (
        !this.$store.state.transactions.transactions ||
        !this.$store.state.transactions.transactions.items
      ) {
        return []
      }
      return this.$store.state.transactions.transactions.items
    },
    walletAddress () {
      if (this.$store.state.transactions.walletAddresses.items) {
        const walletId =
          this.$store.state.transactions.walletAddresses.items.find(
            (wallet) => wallet.reason === 'deposit' && wallet.asset === 'USDC'
          )
        if (walletId) {
          return walletId.walletAddress
        }
      }
      return null
    },
    modalWidth () {
      return breakpoints.lgAndUp ? '35%' : breakpoints.mdAndUp ? '70%' : '91%'
    }
  },
  async mounted () {
    await this.getTransferDetails()
  },
  beforeMount () {
    this.transaction = this.currentTransaction
    if (
      this.transaction &&
      Object.keys(this.transaction).length > 0 &&
      this.transactions.status === this.$STATUS.PENDING
    ) {
      this.depositForm.currency = this.$CURRENCY.USD
      this.depositForm.amount = this.transaction.amount
      // this.transferLocations[2].disabled = true
      // this.transferLocations[1].currency = true
    }
  },
  watch: {
    'depositForm.amount': function (newValue) {
      const result = newValue
        .toString()
        .split('.')[0]
        .replace(/\D/g, '')
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        .replace(/^0+/g, '')
      this.$nextTick(() => {
        this.depositForm.amount = newValue.toString().split('.')[1]
          ? `${this.currencySymbol}${result}.${
              newValue.toString().split('.')[1]
            }`
          : `${this.currencySymbol}${result}`
      })
    },
    deep: true
  },
  components: {
    AccountInformation: () =>
      import('@/components/deposit/AccountInformation.vue'),
    LocalAccountInformation: () =>
      import('@/components/deposit/LocalAccountInformation.vue'),
    AssetAccountInformation: () =>
      import('@/components/deposit/AssetAccountInformation.vue'),
    WarningIcon: () => import('@/assets/icons/WarningIcon.vue'),
    PlaidAccountsDialog: () =>
      import('@/components/deposit/PlaidAccountsDialog.vue')
  },
  destroyed () {
    this.$store.dispatch('transactions/setCurrentTransaction', {})
    this.$store.dispatch('transactions/resetLocalDepositInfo', {})
    this.$store.dispatch('transactions/wireTransferType', '')
    this.$store.dispatch('transactions/setDepositTypeView', 'depositType')
  }
}
</script>

<style scoped>
>>> .el-input__inner:focus {
  border-color: #818799;
}
>>> .el-input__inner {
  background-color: var(--background);
  color: var(--text-1);
  height: 50px;
  border: 1px solid var(--text-5);
}
>>> .el-input__inner {
  border-radius: 8px;
  border-color: var(--text-5);
  height: 48px;
}
>>> .el-form--label-top .el-form-item__label {
  padding: 0;
}
>>> .el-form-item {
  margin-bottom: 10px;
}
>>> .el-form-item__label {
  margin-bottom: -8px;
}
>>> .el-button:focus,
>>> .el-button:hover {
  color: white;
  opacity: 0.8;
  border-color: #c7c8d2;
  background-color: var(--color-primary);
}
.small-text {
  font-size: 10px;
}
</style>
